import React, { PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from '../../../../global/button/Button'
import { ExpandableBasicModalMobile } from '../ExpandableModal/ExpandableBasicModalMobile'
import { cloneButtonLarge, getSortedButtons } from '../common/helpers/button'
import { InfoModalProps } from './InfoModal'

export const InfoModalMobile: React.FC<PropsWithChildren<InfoModalProps>> = (props) => {
  const { t } = useTranslation()

  const { title, children } = props
  const { onClose } = props

  return (
    <ExpandableBasicModalMobile
      title={title}
      renderFooter={({ onClose }) =>
        getSortedButtons(props, [
          cloneButtonLarge(
            <Button.New appearance='secondary' onClick={onClose}>
              {t('Close')}
            </Button.New>
          ),
        ])
      }
      onClose={onClose}
    >
      {children}
    </ExpandableBasicModalMobile>
  )
}
